import { Stack, Text } from '@pairy/pds-react';

import { FormRecordProps } from '../index.type';
import * as Styled from '../index.styles';

interface Props extends FormRecordProps<boolean> {
  title: string;
  description?: string;
  isRequired: boolean;
  link: string;
}

const Legal = ({
  id,
  isRequired,
  title,
  description,
  link,
  handleChangeWithId,
  translateKoToEn,
  value,
}: Props) => {
  const openWindow = () => {
    window.open(link, '_blank');
  };

  return (
    <Stack gap={4} direction="column" justifyContent="flex-start">
      <Text variant="sm-semibold" as="label">
        <Stack gap={4} alignItems="center">
          <Styled.MinWidthWrapper width={24} height={24}>
            <Styled.CheckBoxInput
              type="checkbox"
              onChange={() => {
                handleChangeWithId(id, !value);
              }}
              checked={value}
            />
          </Styled.MinWidthWrapper>
          <Styled.MinWidthWrapper width={35}>
            {isRequired ? (
              <Text variant="md-semibold" color="skyblue_500">
                ({translateKoToEn('required')})
              </Text>
            ) : (
              <Text variant="md-semibold">({translateKoToEn('optional')})</Text>
            )}
          </Styled.MinWidthWrapper>
          <button onClick={openWindow}>
            <Styled.KeepAllText variant="md-semibold">
              {title}
            </Styled.KeepAllText>
          </button>
        </Stack>
      </Text>
      {description && (
        <Styled.KeepAllText as="div" variant="sm-medium" color="zinc_400">
          {description}
        </Styled.KeepAllText>
      )}
    </Stack>
  );
};

export default Legal;
